import { render, staticRenderFns } from "./CardFlag.vue?vue&type=template&id=5ac92ca6&scoped=true&"
import script from "./CardFlag.vue?vue&type=script&lang=ts&"
export * from "./CardFlag.vue?vue&type=script&lang=ts&"
import style0 from "./CardFlag.vue?vue&type=style&index=0&id=5ac92ca6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac92ca6",
  null
  
)

export default component.exports